
  import AboutSubHeader from '~/components/about/sub-header.vue'
  import { getCommerceContact } from '~/api/about/index.js'
  export default {
    name: 'About',
    components: { AboutSubHeader },
    layout: 'template-page',
    data() {
      return {
        marketInfo: {
          name: '拓女士',
          email: 'lx.tuo@wenjuan.com',
          phone: '133 0167 9863',
        },
        // 战略资本认同
        strategyList: [
          {
            year: 2013,
            list: ['首次获得联想控股旗下 联想之星、联想集团的联合投资'],
          },
          {
            year: 2015,
            list: ['再获华溢资本以及联想的追加投资'],
          },
          {
            year: 2019,
            list: ['获得方广资本领投的第三轮投资'],
          },
          {
            year: 2021,
            list: ['获得IDG领投的C+轮融资'],
          },
        ],
        // 部分奖项及荣誉
        honorList: [
          {
            year: 2017,
            list: ['中国调研合作方大奖/项目创新奖'],
          },
          {
            year: 2018,
            list: ['苏南国家自主创新示范区瞪羚企业', '金梧奖“年度客户体验营销平台”'],
          },
          {
            year: 2019,
            list: ['中国中小企业协会颁发的“专精特新”中小企业认定'],
          },
          {
            year: 2020,
            list: [
              '金指尖奖：最具创新工具类APP/产品',
              '苏州市“独角兽”培育企业',
              '企业服务数字化竞争力Top10（CEM榜）榜首',
            ],
          },
          {
            year: 2021,
            list: ['科技创新优秀发明成果'],
          },
        ],
      }
    },
    fetchOnServer: false,
    async fetch() {
      try {
        await this.initMain()
      } catch (error) {
        console.log('fetch error: ', error)
      }
    },
    head() {
      return {
        title: '关于我们_问卷网',
        link: [{ rel: 'canonical', href: 'https://www.wenjuan.com/about/' }],
        meta: [
          {
            hid: 'keywords',
            name: 'keywords',
            content: '问卷调查网站,市场调查公司,市场研究公司,网络调查公司,在线调查公司,问卷调查公司',
          },
          {
            hid: 'description',
            name: 'description',
            content:
              '免费表单登记平台-问卷网，拥有创新的编辑界面和结果分析界面，海量的问卷和表单模板，提供20余万精品模板；支持微信，微博，QQ等多种发布模式。专注于为企业和个人提供问卷表单的创建，发布，管理，收集及分析服务。',
          },
        ],
      }
    },
    mounted() {
      this.$store.commit('setHightLightHeader', {
        transparent: true,
      })
      window.addEventListener('scroll', this.watchScroll)
    },
    methods: {
      async initMain() {
        try {
          const { data } = await getCommerceContact()
          console.log(data)
          const { name = '', email = '', mobile = '' } = data[0] || {}
          const phoneArr = mobile.trim().split('')
          phoneArr.splice(3, 0, ' ')
          phoneArr.splice(8, 0, ' ')
          Object.assign(this.marketInfo, {
            name,
            email,
            phone: phoneArr.join(''),
          })
        } catch (error) {
          return Promise.reject(error)
        }
      },
      // 跳转路由
      jump(url, query) {
        if (!url) {
          return
        }
        this.$open(url, query)
      },
      watchScroll() {
        const scrollTop = document.documentElement.scrollTop || document.body.scrollTop
        if (scrollTop > 0) {
          this.$store.commit('setHightLightHeader', {
            transparent: false,
          })
        } else {
          this.$store.commit('setHightLightHeader', {
            transparent: true,
          })
        }
      },
    },
  }
